<template>
  <div class="legal-page">
    <mPageTitle
      :title="$t('Termeni și Condiții')"
      :subtitle="$t('legal_terms_subtitle')"
      :description="$t('legal_terms_description')"
      :image="require('@/assets/images/webp/services.webp')"
    />

    <aSection :background="'#fff'">
      <div class="container legal-page__content">
        <div class="legal-page__last-updated">
          {{ $t("legal_last_updated") }}: 06.08.2026
        </div>

        <div class="legal-page__intro">
          <p class="legal-page__intro-service">{{ $t("legal_service") }}</p>
          <p class="legal-page__intro-company">{{ $t("legal_company") }}</p>
          <p class="legal-page__intro-note">{{ $t("terms_intro_accept") }}</p>
        </div>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s1_title") }}</h2>
          <ol class="legal-page__clauses" start="1">
            <li>{{ $t("terms_c1") }}</li>
            <li>{{ $t("terms_c2") }}</li>
            <li>{{ $t("terms_c3") }}</li>
            <li>{{ $t("terms_c4") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s2_title") }}</h2>
          <ol class="legal-page__clauses" start="5">
            <li>{{ $t("terms_c5") }}</li>
            <li>{{ $t("terms_c6") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s3_title") }}</h2>
          <ol class="legal-page__clauses" start="7">
            <li>{{ $t("terms_c7") }}</li>
            <li>{{ $t("terms_c8") }}</li>
            <li>{{ $t("terms_c9") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s4_title") }}</h2>
          <ol class="legal-page__clauses" start="10">
            <li>{{ $t("terms_c10") }}</li>
            <li>{{ $t("terms_c11") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s5_title") }}</h2>
          <ol class="legal-page__clauses" start="12">
            <li>{{ $t("terms_c12") }}</li>
            <li>{{ $t("terms_c13") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s6_title") }}</h2>
          <ol class="legal-page__clauses" start="14">
            <li>{{ $t("terms_c14") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s7_title") }}</h2>
          <ol class="legal-page__clauses" start="15">
            <li>{{ $t("terms_c15") }}</li>
            <li>{{ $t("terms_c16") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s8_title") }}</h2>
          <ol class="legal-page__clauses" start="17">
            <li>{{ $t("terms_c17") }}</li>
            <li>{{ $t("terms_c18") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s9_title") }}</h2>
          <ol class="legal-page__clauses" start="19">
            <li>{{ $t("terms_c19") }}</li>
          </ol>
          <div class="legal-page__cross-ref">
            <p>
              {{ $t("terms_cross_ref") }}
              <router-link :to="privacyPath">
                {{ $t("Politica de Confidențialitate") }}
              </router-link>
              .
            </p>
          </div>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_s10_title") }}</h2>
          <ol class="legal-page__clauses" start="20">
            <li>
              {{ $t("terms_c20_a") }}
              <a href="https://anpc.ro" target="_blank" rel="noopener noreferrer"
                >anpc.ro</a
              >{{ $t("terms_c20_b") }}
              <a href="tel:+40219551">021 9551</a>.
            </li>
            <li>{{ $t("terms_c21") }}</li>
          </ol>
        </section>

        <section class="legal-page__section">
          <h2>{{ $t("terms_contact_title") }}</h2>
          <p>
            {{ $t("terms_contact_p1") }}
            <a href="mailto:office@luxbrumalis.ro">office@luxbrumalis.ro</a>.
          </p>
        </section>
      </div>
    </aSection>
  </div>
</template>

<script>
import mPageTitle from "../components/molecules/m-page-title.vue";
import aSection from "../components/atoms/a-section.vue";

const BASE_URL = "https://jeffbrasov.ro";

export default {
  metaInfo() {
    const lang = this.$i18n.locale;
    const pageUrl = `${BASE_URL}/${lang}/termeni-si-conditii`;
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: this.$t("Acasă"),
          item: `${BASE_URL}/${lang}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: this.$t("Termeni și Condiții"),
          item: pageUrl,
        },
      ],
    };
    return {
      title: this.$t("seo_title_terms"),
      meta: [
        { name: "description", content: this.$t("meta_desc_terms") },
        {
          property: "og:title",
          content: `${this.$t("seo_title_terms")} | Mr Jeff Brașov`,
        },
        { property: "og:description", content: this.$t("meta_desc_terms") },
        { property: "og:url", content: pageUrl },
        { name: "robots", content: "noindex, follow" },
      ],
      link: [
        { rel: "canonical", href: pageUrl },
        {
          rel: "alternate",
          hreflang: "ro",
          href: `${BASE_URL}/ro/termeni-si-conditii`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: `${BASE_URL}/en/termeni-si-conditii`,
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: `${BASE_URL}/ro/termeni-si-conditii`,
        },
      ],
      script: [{ type: "application/ld+json", json: breadcrumbSchema }],
    };
  },
  components: {
    mPageTitle,
    aSection,
  },
  computed: {
    privacyPath() {
      return `/${this.$i18n.locale}/politica-de-confidentialitate`;
    },
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/legal-page.scss";
</style>
